import Vue from 'vue'
import Vuex from 'vuex'
import { setToken, getToken, clearLoginData } from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    userId: '',
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
  },
  actions: {
    Login ({ commit }, data) {
      commit('SET_TOKEN', data.token)
      commit('SET_USER_ID', data.userId)
      setToken(data.token)
      localStorage.setItem('user_id', data.userId);
    },
    GetLocalUserInfo({ commit }, data) {
      if(getToken()) {
        commit('SET_TOKEN', getToken());
        commit('SET_USER_ID', localStorage.getItem('user_id'));
      }
    },
    LoginOut({ commit }) {
      commit('SET_TOKEN', '');
      commit('SET_USER_ID', '');
      clearLoginData();
    }
  }
})
